const {TBT_ENV} = window

// These variables are used in dev, staging AND prod
const commonConfig = {
  DATA_DOG_APP_ID: '37cf510a-d27b-4165-94b9-33bc52987f21',
  DATA_DOG_CLIENT_TOKEN: 'pub8c91f8ffedf8d1dbb5bf7ea5afb80494',
  JWT_AUTH_COOKIE_NAME: 'user_jwt',
  MYTIME_PUBLIC_BOOKING_API: 'https://www.mytime.com/api/mkp/v1',
  TYPEFORM_ADD_REMOVE_ITEMS_URL: 'https://tbtreplacement.typeform.com/to/xLV8HV',
  TYPEFORM_EMBED_URL: 'https://s3-eu-west-1.amazonaws.com/share.typeform.com/embed.js',
  TYPEFORM_EXTENDED_RENTAL_URL: 'https://theblacktux.typeform.com/to/PjzEzc',
  TYPEFORM_LOST_AND_FOUND_URL: 'https://tbtreplacement.typeform.com/to/cqQgkl',
  TYPEFORM_RENT_TO_KEEP_URL: 'https://tbtreplacement.typeform.com/to/HLnWKx',
  TYPEFORM_RENT_TO_KEEP_PRICING_URL: 'https://tbtreplacement.typeform.com/to/EyUzDw',
  TYPEFORM_RETURN_ITEMS_URL: 'https://tbtreplacement.typeform.com/to/dL4Ogw',
  TYPEFORM_TAILORING_REIMBURSEMENT: 'https://tbtreplacement.typeform.com/to/FnkGp5',
}

// These are all the URLS/config used when running TBT SPA locally
const development = {
  ENV: 'local',
  TBT_API_URL: 'https://tbt-staging.com',
  DB_BOOKING_URL: 'https://dbi.technology/blacktux-fitting/',
  FACEBOOK_KEY: '649223755093147',
  GOOGLE_CLOUD_API_KEY: 'AIzaSyC7wswWozQr9rdgAbY_-25exgSKmnBl8uo',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCzKpITFOcX8wbaWAuQN2yc7Ix5WkcBvag',
  SEGMENT_ENABLE: 'False',
  SEGMENT_WRITE_KEY: 'FtD9AkUdTrP49cf1sEKrjDplAn2jSAPh',
  SEGMENT_USER_ID_PREFIX: '6064582-',
  MYTIME_COMPANY_ID: '122734',
  AUTH_SERVICE_URL: 'https://auth.tbt-staging.com',
  FIT_PROFILE_API_URL: 'https://size.tbt-staging.com/fitprofile/user',
  PRODUCT_SERVICE_URL: 'https://products.tbt-staging.com',
  PRODUCT_REVIEW_SERVICE_URL: 'https://product-reviews-staging.theblacktux.com',
  SENTRY_URL: 'https://4291e1af046443b089267a4ce73007a1@sentry.io/232850',
  SIZE_API_KEY: '',
  SIZE_API_URL: 'https://size.tbt-staging.com/sizes/user',
  WORLD_PAY_IFRAME_URL:
    'https://request.eprotect.vantivprelive.com/eProtect/js/eProtect-iframe-client.min.js',
  YOTPO_API_KEY: 'qVSvkCVNP9x6C1k8uoXbqBqrzFqsWX7CmtMtjRVp',
  ...commonConfig,
}

// This config is used when running JS unit tests
// See /tests/js/globalSetup/TBT.js
const testing = {
  TBT_API_URL: '',
  APPOINTMENT_PLUS_ENV: {},
  AUTH_SERVICE_URL: '',
  FIT_PROFILE_API_URL: '',
  JWT_AUTH_COOKIE_NAME: '',
  MYTIME_COMPANY_ID: '',
  MYTIME_PUBLIC_BOOKING_API: '',
  SENTRY_URL: '',
  SEGMENT_ENABLE: 'False',
  SIZE_API_KEY: '',
  SIZE_API_URL: '',
  PRODUCT_SERVICE_URL: '',
  PRODUCT_REVIEW_SERVICE_URL: '',
  YOTPO_API_KEY: '',
}

const devOverwrites = {
  ENV: 'dev',
  TBT_API_URL: 'https://tbt-staging.com',
  FACEBOOK_KEY: '424943327571234',
  SEGMENT_ENABLE: 'True',
  SEGMENT_USER_ID_PREFIX: 'c0f1f1f-',
  AUTH_SERVICE_URL: 'https://auth.tbt-staging.com',
  FIT_PROFILE_API_URL: 'https://size.tbt-staging.com/fitprofile/user',
  PRODUCT_SERVICE_URL: 'https://products.tbt-staging.com',
  SENTRY_URL: 'https://c846f5010d454a46a443c099748f9856@sentry.io/232889',
  SIZE_API_KEY: 'Z8wZHbLv9N7XTbQAQlOQP3KcioR3n8s38IhK3wOW',
  SIZE_API_URL: 'https://size.tbt-staging.com/sizes/user',
}
const dev = Object.assign({}, development, devOverwrites)

const stagingOverwrites = {
  ENV: 'staging',
  TBT_API_URL: 'https://tbt-staging.com',
  FACEBOOK_KEY: '424943327571234',
  SEGMENT_ENABLE: 'True',
  SEGMENT_USER_ID_PREFIX: 'c0f1f1f-',
  AUTH_SERVICE_URL: 'https://auth.tbt-staging.com',
  FIT_PROFILE_API_URL: 'https://size.tbt-staging.com/fitprofile/user',
  PRODUCT_SERVICE_URL: 'https://products.tbt-staging.com',
  SENTRY_URL: 'https://c846f5010d454a46a443c099748f9856@sentry.io/232889',
  SIZE_API_KEY: 'Z8wZHbLv9N7XTbQAQlOQP3KcioR3n8s38IhK3wOW',
  SIZE_API_URL: 'https://size.tbt-staging.com/sizes/user',
}
const staging = Object.assign({}, development, stagingOverwrites)

const production = {
  ENV: 'production',
  // TBT_API_URL: 'https://theblacktux.com',
  TBT_API_URL: 'https://rent.theblacktux.com',
  DB_BOOKING_URL: 'https://www.davidsbridal.com/blacktux-fitting/',
  FACEBOOK_KEY: '320597481374273',
  GOOGLE_CLOUD_API_KEY: 'AIzaSyC7wswWozQr9rdgAbY_-25exgSKmnBl8uo',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCzKpITFOcX8wbaWAuQN2yc7Ix5WkcBvag',
  SEGMENT_ENABLE: 'True',
  SEGMENT_WRITE_KEY: 'KI5MDIG5bffCEHMXqj4VhthRO1eWTe35',
  SEGMENT_USER_ID_PREFIX: '',
  MYTIME_COMPANY_ID: '122584',
  AUTH_SERVICE_URL: 'https://auth.theblacktux.com',
  FIT_PROFILE_API_URL: 'https://size.theblacktux.com/fitprofile/user',
  NEW_ADMIN_BASE_URL: 'https://admin.theblacktux.net',
  PRODUCT_SERVICE_URL: 'https://products.theblacktux.com',
  PRODUCT_REVIEW_SERVICE_URL: 'https://product-reviews.theblacktux.com',
  SENTRY_URL: 'https://711bfa758b724102a386dadd5979319a@sentry.io/232890',
  SIZE_API_KEY: 'btdPcYcfnW6PEXHgqvfcY8a5Hkw6iGrB7mMpZaAI',
  SIZE_API_URL: 'https://size.theblacktux.com/sizes/user',
  WORLD_PAY_IFRAME_URL:
    'https://request.eprotect.vantivcnp.com/eProtect/js/eProtect-iframe-client3.min.js',
  YOTPO_API_KEY: 'qVSvkCVNP9x6C1k8uoXbqBqrzFqsWX7CmtMtjRVp',
  ...commonConfig,
}

const configsByEnv = {
  local: development,
  development,
  dev,
  staging,
  production,
  test: testing,
}

export const getEnvConfig = (env) => {
  return configsByEnv[env] || production
}

const serviceConfig = getEnvConfig(TBT_ENV)

export default serviceConfig
